module.exports = __webpack_public_path__ + "img/logo-neofor.5a61b61e.webp";